var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ele-chart',{attrs:{"option":_vm.option},on:{"done":_vm.onChartDone}})
}
var staticRenderFns = []

export { render, staticRenderFns }